import { gql } from '@apollo/client';

export const SEARCH_DASHBOARD_GENERAL = gql`
  query searchDashboardGeneral($data: PatientDashboardInput!) {
    patientDashboard(data: $data) {
      data {
        patientId
        patientName
        email
        phonenumber
        alertsCount
        staffName
        assessmentStatus
        primaryPharmacistName
        assessmentId
        processingAssessmentId
      }
      count
      staffMembers
      patientsWithAlertsUnresolved
      assessmentsIncomplete
    }
  }
`;
